import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormService } from 'src/app/services/form/form.service';

@Component({
  selector: 'app-case-started',
  template: '<app-loading-screen></app-loading-screen>',
})
export class CaseStartedComponent implements OnInit {

  constructor(
    private formService: FormService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    setTimeout(
      () => {
        this.formService.redirectToCases(this.route.snapshot.queryParams.payee_case_reference_id);
      },
      2_000,
    );
  }

}
